import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { environment } from "../../environments/environment";

export function apiPrefixInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  // 检查是否是绝对路径，且不属于当前域名
  const isHttpAbsolute = req.url.startsWith('http://') || req.url.startsWith('https://');
  if (isHttpAbsolute && !req.url.startsWith(window.location.origin)) {
    return next(req);
  }

  // 获取不带查询参数和哈希的纯路径用于判断
  const urlWithoutQuery = req.url.split('?')[0].split('#')[0];

  // 检查是否是静态资源（assets 目录或常见静态文件后缀）
  const isStaticResource = urlWithoutQuery.match(/\.(js|css|html|json|svg|png|jpe?g|gif|ico|woff2?|ttf|eot)$/i) || 
                           urlWithoutQuery.includes('/assets/') || 
                           urlWithoutQuery.startsWith('assets/');
                           
  if (isStaticResource) {
    return next(req);
  }

  // 防止重复添加前缀
  let path = isHttpAbsolute ? req.url.slice(window.location.origin.length) : req.url;
  if (!path.startsWith('/')) {
    path = '/' + path;
  }
  
  const prefix = environment.gatewayApi.endsWith('/') 
    ? environment.gatewayApi.slice(0, -1) 
    : environment.gatewayApi;

  if (path === prefix || path.startsWith(prefix + '/')) {
    return next(req);
  }

  // 组装新的 URL
  const newUrl = isHttpAbsolute 
    ? `${window.location.origin}${prefix}${path}`
    : `${prefix}${path}`;

  const apiReq = req.clone({ url: newUrl });
  return next(apiReq);
}
